import { render } from "./SetParent.vue?vue&type=template&id=2496e9a1&scoped=true&lang=pug"
import script from "./SetParent.vue?vue&type=script&lang=js"
export * from "./SetParent.vue?vue&type=script&lang=js"

import "./SetParent.vue?vue&type=style&index=0&id=2496e9a1&scoped=true&lang=scss"

import exportComponent from "/builds/wiwdata/applications/finance-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2496e9a1"]])

export default __exports__